'use client'

import { useEffect } from 'react'

type WindowEvent<T extends string> = T extends keyof WindowEventMap ? WindowEventMap[T] : Event

export function useWindowEvent<WindowEventKey extends string>(
  event: WindowEventKey,
  listener: (event: WindowEvent<WindowEventKey>) => unknown,
  options?: { once?: boolean; passive?: boolean }
) {
  useEffect(() => {
    const once = options?.once ?? false
    const passive = options?.passive ?? false
    window.addEventListener(
      event as keyof WindowEventMap,
      listener as (event: WindowEventMap[keyof WindowEventMap]) => unknown,
      { once, passive }
    )
    return () =>
      window.removeEventListener(
        event as keyof WindowEventMap,
        listener as (event: WindowEventMap[keyof WindowEventMap]) => unknown
      )
  }, [event, listener, options])
}
